/* eslint-disable */
import moment from "moment";
import { isEqualDate } from "./dateUtils";

export function timelineCalculating({ dateList, bookingList, bookingDate, viewType }) {
  const timeline = [];

  let startTime = 8;
  const endTime = 20;
  const interval = 0.5;
  let rowIndex = 0;

  while (startTime < endTime) {
    const timelineItem = {
      startValue: startTime,
      endValue: startTime + interval,
      label: `${startTime < 10 ? "0" : ""}${Math.floor(startTime)}:${Number.isInteger(startTime) ? "00" : "30"}`,
      bookingData: []
    };

    if (!viewType) {
      let bookingIndex = 0;
      const bookingItem = {
        ...bookingList.find(
          booking =>
            (booking.StartTime === startTime || (booking.StartTime < startTime && booking.EndTime > startTime)) &&
            booking.MeetingDay === moment(bookingDate).format("YYYY-MM-DD")
        )
      };

      if (bookingItem.ID && timeline[rowIndex - 1]) {
        const prevBookingDataItem = timeline[rowIndex - 1].bookingData[bookingIndex];
        if (prevBookingDataItem.ID === bookingItem.ID) {
          prevBookingDataItem.isSpan = true;
          bookingItem.hideData = true;
        }
      }
      bookingIndex++;

      const today = new Date();
      const compareDate = new Date(bookingDate);
      compareDate.setHours(startTime, Number.isInteger(startTime) ? 0 : 30);

      bookingItem.isDisabled = compareDate.getTime() <= today.getTime();
      timelineItem.bookingData.push({ ...bookingItem, bookingDate });
    } else {
      let bookingIndex = 0;
      dateList.forEach(date => {
        const bookingItem = {
          ...bookingList.find(
            booking =>
              (booking.StartTime === startTime || (booking.StartTime < startTime && booking.EndTime > startTime)) &&
              booking.MeetingDay === moment(date).format("YYYY-MM-DD")
          )
        };

        if (bookingItem.ID && timeline[rowIndex - 1]) {
          const prevBookingDataItem = timeline[rowIndex - 1].bookingData[bookingIndex];
          if (prevBookingDataItem.ID === bookingItem.ID) {
            prevBookingDataItem.isSpan = true;
            bookingItem.hideData = true;
            if (!bookingItem.moreInfo) {
              bookingItem.moreInfo = bookingItem.Description;
            }
          }
        }

        const today = new Date();
        const compareDate = new Date(date);
        compareDate.setHours(startTime, Number.isInteger(startTime) ? 0 : 30);

        bookingItem.isDisabled = compareDate.getTime() <= today.getTime();

        bookingIndex++;
        timelineItem.bookingData.push({ ...bookingItem, bookingDate: date });
      });
    }

    timeline.push(timelineItem);
    startTime += interval;
    rowIndex++;
  }

  return timeline;
}

export function timeListCalculating(bookingDate, bookingList, startTime, isEdit) {
  const timeList = [
    {
      label: "08:00",
      value: 8,
      canStart: true,
      canEnd: true
    },
    {
      label: "08:30",
      value: 8.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "09:00",
      value: 9,
      canStart: true,
      canEnd: true
    },
    {
      label: "09:30",
      value: 9.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "10:00",
      value: 10,
      canStart: true,
      canEnd: true
    },
    {
      label: "10:30",
      value: 10.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "11:00",
      value: 11,
      canStart: true,
      canEnd: true
    },
    {
      label: "11:30",
      value: 11.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "12:00",
      value: 12,
      canStart: true,
      canEnd: true
    },
    {
      label: "12:30",
      value: 12.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "13:00",
      value: 13,
      canStart: true,
      canEnd: true
    },
    {
      label: "13:30",
      value: 13.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "14:00",
      value: 14,
      canStart: true,
      canEnd: true
    },
    {
      label: "14:30",
      value: 14.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "15:00",
      value: 15,
      canStart: true,
      canEnd: true
    },
    {
      label: "15:30",
      value: 15.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "16:00",
      value: 16,
      canStart: true,
      canEnd: true
    },
    {
      label: "16:30",
      value: 16.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "17:00",
      value: 17,
      canStart: true,
      canEnd: true
    },
    {
      label: "17:30",
      value: 17.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "18:00",
      value: 18,
      canStart: true,
      canEnd: true
    },
    {
      label: "18:30",
      value: 18.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "19:00",
      value: 19,
      canStart: true,
      canEnd: true
    },
    {
      label: "19:30",
      value: 19.5,
      canStart: true,
      canEnd: true
    },
    {
      label: "20:00",
      value: 20,
      canStart: true,
      canEnd: true
    }
  ];

  const today = new Date();

  const isEqual = isEqualDate(today, bookingDate);

  const compareValue = today.getHours() + (today.getMinutes() >= 30 ? 0.5 : 0);

  timeList.forEach(time => {
    const bookingData = bookingList.find(
      booking =>
        (booking.StartTime === time.value || (booking.StartTime < time.value && booking.EndTime > time.value)) &&
        booking.MeetingDay === moment(bookingDate).format("YYYY-MM-DD")
    );

    if (isEqual && compareValue >= time.value) {
      time.canStart = false;
      time.canEnd = false;
    }

    if (bookingData) {
      time.canStart = isEdit && bookingData.StartTime === startTime;
    }

    if (startTime > 0) {
      if (time.value <= startTime) {
        time.canEnd = false;
      }

      const nextBookingData = bookingList.find(
        booking => booking.StartTime > startTime && booking.MeetingDay === moment(bookingDate).format("YYYY-MM-DD")
      );

      if (nextBookingData && nextBookingData.StartTime < time.value) {
        time.canEnd = false;
      }
    }
  });

  return timeList;
}



// WEBPACK FOOTER //
// ./src/utils/meetingTimeline.js